// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"d7339090","211":"24d34a9e","787":"c13088a6"}[chunkId] + ".chunk.js";
};